<template>
  <td>{{ value }}</td>
</template>

<script lang="babel">
export default {
    props: ['content'],
    computed: {
      value() {
        const formatter = new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2,
        });

        return formatter.format(this.content);
      }
    }
};
</script>
